import React from 'react';
import { Dialog } from '@mui/material';
import UpdateForm from './UpdateForm';

const UpdateModal = ({
  open,
  toggle,
  getData,
  data,
  billingRoles,
  tracks,
  allSkills,
  allEmployees,
  projectCode,
  setSnackBarOpen,
  setSnackbarSeverity,
  setSnackBarMessage,
  projectDetails
}) => {
  return (
    <Dialog
      open={open}
      keepMounted
      maxWidth="md"
      fullWidth
      scroll="paper"
      onClose={toggle}
    >
      <UpdateForm
        projectDetails={projectDetails}
        open={open}
        toggle={toggle}
        getData={getData}
        data={data}
        billingRoles={billingRoles}
        tracks={tracks}
        allSkills={allSkills}
        allEmployees={allEmployees}
        projectCode={projectCode}
        setSnackBarOpen={setSnackBarOpen}
        setSnackbarSeverity={setSnackbarSeverity}
        setSnackBarMessage={setSnackBarMessage}
      />
    </Dialog>
  );
};

export default UpdateModal;
